module.exports = __webpack_public_path__ + "static/tei-icon-f8c5bc1390b07ef1d75963cac798aec0.png";